import { Instance } from 'mobx-state-tree';
import { VisitLoadDtoModelBase } from './VisitLoadDtoModel.base';

/* The TypeScript type of an instance of VisitLoadDtoModel */
export interface VisitLoadDtoModelType extends Instance<typeof VisitLoadDtoModel.Type> {}

/* A graphql query fragment builders for VisitLoadDtoModel */
export { selectFromVisitLoadDto, visitLoadDtoModelPrimitives, VisitLoadDtoModelSelector } from './VisitLoadDtoModel.base';

/**
 * VisitLoadDtoModel
 */
export const VisitLoadDtoModel = VisitLoadDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
